import keycodes from 'keycodes'
import * as React from 'react'
import type {KeyboardEvent} from 'react'

import {cloneCreateOrCall} from '@base/react-utils'

type RequiredChildProps = {
  onKeyDown?: (a: KeyboardEvent) => void
}

type ConfirmationKeysProps = {
  onConfirm?: ((a: KeyboardEvent) => void) | null
  onCancel?: ((a: KeyboardEvent) => void) | null
  onKeyDown?: ((a: KeyboardEvent) => void) | null
  children:
    | React.ComponentType<RequiredChildProps>
    | React.ReactElement<RequiredChildProps>
  confirmationKeyNames?: Array<string>
}

export default function ConfirmationKeys({
  onConfirm,
  onCancel,
  onKeyDown,
  children,
  confirmationKeyNames = ['enter'],
  ...props
}: ConfirmationKeysProps) {
  return cloneCreateOrCall(children, {
    ...props,

    onKeyDown(event: KeyboardEvent) {
      const confirmationKeyCodes = confirmationKeyNames.map(keycodes)
      const {keyCode, defaultPrevented, altKey, metaKey, ctrlKey} = event
      if (!defaultPrevented && !altKey && !metaKey && !ctrlKey) {
        if (onConfirm && confirmationKeyCodes.includes(keyCode)) {
          onConfirm(event)
          event.persist() // persist synthetic event so it can be accessed in options
          event.preventDefault()
        } else if (onCancel && keyCode === keycodes('escape')) {
          onCancel(event)
          event.preventDefault()
        }
      }
      if (onKeyDown) onKeyDown(event)
    },
  })
}
